import { atom, type PrimitiveAtom } from 'jotai';

export type NamedTypeRef = {
	kind: 'NAMED';
	name: string;
};

export type ListTypeRef = {
	kind: 'LIST';
	ofType: TypeRef;
};

export type NonNullTypeRef = {
	kind: 'NON_NULL';
	ofType: TypeRef;
};

export type TypeRef = NamedTypeRef | ListTypeRef | NonNullTypeRef;

export type FieldArg = {
	name: string;
	description?: string | null;
	type: TypeRef;
	defaultValue?: string | null;
	isDeprecated?: boolean;
	deprecationReason?: string | null;
};

export type FieldDef = {
	name: string;
	description?: string | null;
	type?: TypeRef;
	args?: FieldArg[];
	isDeprecated?: boolean;
	deprecationReason?: string | null;
	inputType?: TypeRef;
};

export type TypeEntry = {
	name: string;
	kind: 'OBJECT' | 'INTERFACE' | 'UNION' | 'ENUM' | 'SCALAR' | 'INPUT_OBJECT' | 'UNKNOWN';
	description?: string | null;
	fields?: FieldDef[];
	interfaces?: string[];
	possibleTypes?: string[];
	values?: {
		name: string;
		description?: string | null;
		isDeprecated?: boolean;
		deprecationReason?: string | null;
	}[];
};

export type TypesByName = Record<string, TypeEntry>;

export type GraphQLSchemaVariant = 'internal' | 'external';

export const GraphQLSchemaLoadingAtom: PrimitiveAtom<boolean> & {
	init: boolean;
} = atom<boolean>(false);
export const GraphQLSchemaErrorAtom: PrimitiveAtom<string | null> & {
	init: string | null;
} = atom<string | null>(null);
export const GraphQLSchemaTypesByNameAtom: PrimitiveAtom<TypesByName | null> & {
	init: TypesByName | null;
} = atom<TypesByName | null>(null);
export const GraphQLSchemaVariantAtom: PrimitiveAtom<GraphQLSchemaVariant> & {
	init: GraphQLSchemaVariant;
} = atom<GraphQLSchemaVariant>('internal');

export const GraphQLSchemaReloadKeyAtom: PrimitiveAtom<number> & {
	init: number;
} = atom(0);

// Action atom to flush schema state
